// extracted by mini-css-extract-plugin
module.exports = {"leftMenu":"leftMenu_leftMenu__dPd3_"};